import React from 'react';
import ActionButton from '../components/ActionButton';

const AboutPage = () => (
  <main className="about-page">
    <section className="about-hero">
      <div className="about-hero-content">
        <p className="eyebrow">Our story</p>
        <h1>Food, service, and event support from one Asaba kitchen.</h1>
        <p>
          Vemmac Kitchen grew from daily meals served to local customers into a kitchen that also
          supports events, catering teams, and family gatherings across Delta State.
        </p>
        <div className="hero-actions">
          <ActionButton to="/menu" variant="primary" size="xs">Browse menu</ActionButton>
          <ActionButton to="/services" variant="outline" size="xs">Explore services</ActionButton>
        </div>
      </div>
      <div className="about-hero-image">
        <img
          src="https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?auto=format&fit=crop&w=900&q=80"
          alt="Prepared Nigerian dishes at Vemmac Kitchen"
        />
      </div>
    </section>

    <section className="about-section">
      <h2>Who we are</h2>
      <div className="about-section-content">
        <div className="about-section-text">
          <p>
            We cook familiar Nigerian meals with the consistency customers need for daily ordering,
            family packs, and larger celebrations. The same care guides our catering and rental work:
            clear communication, clean equipment, and food served with attention.
          </p>
          <p>
            Our shop remains the center of the experience. It keeps the menu practical, the kitchen
            grounded, and the team close to the customers we serve every day.
          </p>
        </div>
        <div className="about-section-stats">
          <div className="stat-card">
            <div className="stat-number">10+</div>
            <div className="stat-label">Years serving customers</div>
          </div>
        </div>
      </div>
    </section>

    <section className="about-values">
      <h2>What guides us</h2>
      <div className="values-grid">
        <div className="value-card">
          <h3>Fresh preparation</h3>
          <p>Meals are prepared with care so everyday orders and event meals both feel dependable.</p>
        </div>
        <div className="value-card">
          <h3>Clear service</h3>
          <p>We keep ordering, bookings, pickups, and delivery expectations simple and transparent.</p>
        </div>
        <div className="value-card">
          <h3>Event readiness</h3>
          <p>From catering to rental support, we help customers prepare with less stress.</p>
        </div>
      </div>
    </section>

    <section className="about-menu">
      <h2>What we offer</h2>
      <div className="about-menu-content">
        <div className="about-menu-text">
          <p>
            The menu covers daily meals, combos, proteins, sides, and family-friendly portions.
            Catering extends that kitchen into events, while rentals support hosts and food teams
            who need reliable equipment.
          </p>
        </div>
        <div className="about-menu-highlights">
          <div>
            <h4>Daily meals</h4>
            <p>Jollof, fried rice, soups, sides, and proteins prepared for pickup or delivery.</p>
          </div>
          <div>
            <h4>Catering</h4>
            <p>Menu planning and service support for intimate gatherings and larger celebrations.</p>
          </div>
          <div>
            <h4>Rentals</h4>
            <p>Utensils and cooking equipment maintained for clean, practical event use.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="about-why-choose">
      <h2>Why customers choose Vemmac Kitchen</h2>
      <div className="why-choose-grid">
        <div className="why-choose-card">
          <h3>Consistent food</h3>
          <p>Customers can order familiar meals and expect reliable quality from the kitchen.</p>
        </div>
        <div className="why-choose-card">
          <h3>Practical support</h3>
          <p>Ordering, catering, and rental requests are handled with clear next steps.</p>
        </div>
        <div className="why-choose-card">
          <h3>Local focus</h3>
          <p>We serve Asaba and surrounding communities with food and service built for real occasions.</p>
        </div>
      </div>
    </section>
  </main>
);

export default AboutPage;
